import { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import AbstractCondition from './abstract';
import { addError } from './abstract';

export const all = 'and';
export const any = 'or';

class GroupCondition extends AbstractCondition {
  type = 'group';

  trackedAttributes = ['operator'];

  operator: 'and' | 'or' = all;

  @computed('children.[]')
  get errors() {
    let errors = {};

    if (isEmpty(this.children)) {
      addError(errors, 'group', "can't be empty");
    }

    return errors;
  }

  toString() {
    return 'GroupCondition';
  }

  @action
  duplicate() {
    let duplicate = GroupCondition.create();
    this.copyAllAttributes(this, duplicate);
    return duplicate;
  }

  copyAllAttributes(source: GroupCondition, target: GroupCondition) {
    target.setProperties({
      operator: source.operator,
      children: [...source.children],
      _originalChildren: [...source._originalChildren],
    });
  }
}

export default GroupCondition;
